module.exports = __webpack_public_path__ + "img/icon-message2-mew.1b2f87fd.svg";